module.exports = "<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"text-danger bg-danger text-center block-danger\">\n            <h3>App not enabled!</h3>\n            <p class=\"message\">\n                This app is not enabled. Please contact your administrator if you believe this to be a mistake.\n            </p>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/apps/shared/templates/appNotEnabled.html
// module id = 562
// module chunks = 7